import script from "./Automatically_Publish_videos.vue?vue&type=script&setup=true&lang=js"
export * from "./Automatically_Publish_videos.vue?vue&type=script&setup=true&lang=js"

import "./Automatically_Publish_videos.vue?vue&type=style&index=0&id=d6050998&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6050998"]])

export default __exports__